<template> 
    <v-sheet color="transparent" class="containerAreaSheet ma-4" >
        <EasyDataTable
        v-if="finalData.length > 0"
        table-class-name="customize-table"
        show-index
        :headers="finalHeader"
        :items="finalData"
        :rows-per-page="25"
        @click-row="showDialog"
        >
        <template
        v-for="n in maxCountHeader" 
        :key="'estado' + n"
        v-slot:[`item-estado${n}`]="item">
            <span v-if="item[`ip${n}`]">
                <v-icon :color="getColorStatus(item[`latencia${n}`])">mdi-circle</v-icon>
            </span>
        </template>    
        
        </EasyDataTable>

    </v-sheet>

    <v-dialog v-model="dialogValue" width="90%">
        <ResetDialog
        :finalIPS="finalIPS"
        />
    </v-dialog>
</template>


<script setup lang="ts">
import { onMounted, ref } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import ResetDialog from '@/components/SmartLink/dialog/ResetDialog.vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore }         from 'vuex';
const store         = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 *********** SERVICES ***********
 *******************************/
import { getClientStatusData } from '@/services/Smartlink/Reset';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { getColorStatus } from '@/functions/project'

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';
import { RESET_HEADER } from '@/constants/tableHeaders'

/********************************
 ********** INTERFACES **********
 *******************************/
import { HEADER } from '@/interfaces/SmartLink/Tables';
import { CLIENT_STATUS_TABLE } from '@/interfaces/SmartLink/Equipos';

/**
 * Lista de equipos relacionados por el nombre. Hay varios equipos en una sola fila
 */
const finalData = ref([])

/**
 * HEADER de la tabla, inicia con las columnas obtenidas por RESET_HEADER,
 * luego se realizan "push" dependendo de la cantidad de IPs agregadas
 */
const finalHeader = ref(RESET_HEADER)


/**
 * Cantidad de columnas(x3) a agregar a los HEADERS, dependiendo
 * de la cantidad de equipos que se encuentren en la fila
 */
const maxCountHeader = ref(0)

async function getAllClientStatusData(){
    const allData = await getClientStatusData()
    
    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        finalData.value = allData.data.allArrays
        maxCountHeader.value = allData.data.maxCount
    }
}


/**
 * Muestra el dialogo cuando se coloca en TRUE
 */
const dialogValue = ref(false)

/**
 * Lista de las IPs de los equipos obtenidos de una sola fila, al ser seleccionado 
 * para mostrar su información en el diálogo con gráficos 
 */
const finalIPS  = ref<string[]>([])

/**
 * Muestra el dialogo con los gráficos de los equipos. 
 * Además se extrae las IPs de los equipos de cada fila
 * @param item Toda la fila de datos con varios equipos dentro
 */
function showDialog(item:CLIENT_STATUS_TABLE){
     finalIPS.value = Object.entries(item)
    .filter(([key]) => key.startsWith("ip"))
    .map(([, value]) => value)
    dialogValue.value = true;
}

/**
 * Agrega 3 columnas (radio, estado y fecha) por cada equipo agregado del equipo, 
 * todo considerando el valor de maxCountHeader
 */
async function getAllHeaderTable(){
    const head = ref<HEADER[]>([])
    for(let i = 1; i<= maxCountHeader.value; i++){
        head.value.push(
            { text: `Radio #${i}`,           value: `radio${i}`,         sortable: true},
            { text: `Estado #${i}`,          value: `estado${i}`,        sortable: true},
            { text: `Ultima Fecha #${i}`,    value: `fecha${i}`,         sortable: true},
        )
    }
    finalHeader.value = head.value
}


onMounted(async()=>{
   await getAllClientStatusData();
   await getAllHeaderTable()
})

</script>